import React, { useState } from "react";
import { useLogin } from "../LoginProvider";
import "./ForgotPassword.css";

export default function ForgotPassword({ isOpen, onClose }) {
  const { forgotPasswordEmail, loading, error, setError } = useLogin();
  const [email, setEmail] = useState("");

  if (!isOpen) return null;

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    await forgotPasswordEmail(email.trim());
    onClose();
  };

  return (
    <div className="modal-overlay-forgot">
      <div className="modal-content-forgot">
        <button className="close-btn-forgot" onClick={onClose}>
          ×
        </button>
        <h2 className="title-forgot">Mot de passe oublié</h2>

        <form onSubmit={onSubmit} className="form-forgot">
          <label className="label-forgot">E-mail</label>
          <input
            type="email"
            className="input-forgot"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="votre@email.com"
            required
          />
          <button
            disabled={loading}
            type="submit"
            className="submit-btn-forgot"
          >
            {loading ? "Envoi..." : "Envoyer le lien"}
          </button>
        </form>

        {error ? <p className="error-forgot">{error}</p> : null}
      </div>
    </div>
  );
}
